<template>
  <v-card>
    <v-card-title primary-title class="greyk lighten-4k">
      <h4 class="headline mb-0">{{ $t('classes') }}</h4>
      <v-btn icon color="primary" @click="showD=!showD" class="elevation-5">
        <v-icon>add</v-icon>
      </v-btn>

      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        style="max-width:40%"
      ></v-text-field>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <v-data-table
        :headers="classes_headers"
        :items="classes"
        class="elevation-0"
        :search="search"
      >
        <template v-slot:items="props">
          <td>{{ props.index + 1 }}</td>
          <td class="text-xs-center">{{ props.item.name }}</td>
          <td class="text-xs-center">{{ props.item.code?props.item.code:'N/A' }}</td>
          <td class="text-xs-center">{{ props.item.level}}</td>
          <td
            class="text-xs-center"
          >{{ props.item.teacher?props.item.teacher.name : 'N/A' }}</td>
          <td class="text-xs-center">{{ props.item.capacity }}</td>
          <td class="text-xs-center">{{ props.item.students_count }}</td>

          <td class="text-xs-center">
            <v-layout row wrap>
              <!-- <v-flex xs4>
                            <v-btn flat icon color="blue">
                              <v-icon>people_outline</v-icon>
                            </v-btn>
              </v-flex>-->

              <v-flex xs6>
                <v-tooltip bottom>
                  <template v-slot:activator="{on}">
                    <v-btn flat icon @click="showBill(props.item)" v-on="on">
                      <v-icon>money</v-icon>
                    </v-btn>
                  </template>
                  <span>Generate Student Bills</span>
                </v-tooltip>
              </v-flex>

              <v-flex xs6>
                <v-tooltip bottom>
                  <template v-slot:activator="{on}">
                    <v-btn flat icon color="#a29523" @click="showRpt(props.item)" v-on="on">
                      <v-icon>library_books</v-icon>
                    </v-btn>
                  </template>
                  <span>Generate Terminal Reports</span>
                </v-tooltip>
              </v-flex>

              <v-flex xs6>
                <v-btn flat icon color="blue" @click="editclass(props.item)">
                  <v-icon>edit</v-icon>
                </v-btn>
              </v-flex>

              <v-flex xs6>
                <v-btn flat icon color="pink" @click="deleteclass(props.item,props.index)">
                  <v-icon>delete</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </td>
        </template>
      </v-data-table>
    </v-card-text>

    <!-- add-edit class dialog -->
    <cm-dialog pers title="Class" :show="showD">
      <template v-slot:header-actions>
        <v-btn @click="showD=!showD" icon style="cursor:pointer">
          <v-icon>close</v-icon>
        </v-btn>
      </template>

      <template v-slot:content>
        <v-form ref="form">
          <v-text-field label="Name" v-model="class_model.name" :rules="validRules.required" />
          <v-text-field label="Class Code" v-model="class_model.code" />
          <v-autocomplete
            label="Teacher"
            :items="teachers"
            item-text="name"
            item-value="id"
            v-model="class_model.teacher_id"
            :rules="validRules.required"
          ></v-autocomplete>
          <v-text-field
            label="Capacity"
            v-model="class_model.capacity"
            :rules="validRules.required"
          />
          <v-text-field label="Level" v-model="class_model.level" :rules="validRules.required" />
        </v-form>
      </template>

      <template v-slot:footer-actions>
        <v-btn style="cursor:pointer" color="success" @click="saveclass()" :loading="loading">save</v-btn>
        <v-btn @click="showD=!showD" style="cursor:pointer" color="error">close</v-btn>
      </template>
    </cm-dialog>

    <!-- student Bill dialog -->
    <cm-dialog pers title="Student Bill" :show="showB">
      <template v-slot:header-actions>
        <v-dialog
          ref="ntdialog"
          v-model="ntmodal"
          :return-value.sync="next_term_date"
          persistent
          full-width
          width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="next_term_date"
              label="Next Term Begins:"
              prepend-icon="event"
              readonly
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="next_term_date" scrollable>
            <div class="flex-grow-1"></div>
            <v-btn text color="primary" @click="ntmodal = false">Cancel</v-btn>
            <v-btn text color="primary" @click="$refs.ntdialog.save(next_term_date)">OK</v-btn>
          </v-date-picker>
        </v-dialog>
        <v-btn @click="showB=!showB" icon style="cursor:pointer">
          <v-icon>close</v-icon>
        </v-btn>
      </template>
      <template v-slot:content>
        <div>
          <s-bill :selected_classb="selected_classb" :ntb="next_term_date"></s-bill>
        </div>
      </template>

      <template v-slot:footer-actions>
        <v-spacer></v-spacer>
        <v-btn style="cursor:pointer" color="success" icon @click="print('bill')">
          <v-icon>print</v-icon>
        </v-btn>
      </template>
    </cm-dialog>

    <!-- student Academic Report dialog -->
    <cm-dialog pers title="Student Report" :show="showR">
      <template v-slot:header-actions>
        <v-dialog
          ref="ntdialog2"
          v-model="ntmodal2"
          :return-value.sync="next_term_date"
          persistent
          full-width
          width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="next_term_date"
              label="Next Term Begins:"
              prepend-icon="event"
              readonly
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="next_term_date" scrollable>
            <div class="flex-grow-1"></div>
            <v-btn text color="primary" @click="ntmodal2 = false">Cancel</v-btn>
            <v-btn text color="primary" @click="$refs.ntdialog2.save(next_term_date)">OK</v-btn>
          </v-date-picker>
        </v-dialog>
        <v-btn @click="showR=!showR" icon style="cursor:pointer">
          <v-icon>close</v-icon>
        </v-btn>
      </template>
      <template v-slot:content>
        <div>
          <report-card :selected_class="selected_class" :ntbrc="next_term_date"></report-card>
        </div>
      </template>

      <template v-slot:footer-actions>
        <v-spacer></v-spacer>
        <v-btn style="cursor:pointer" color="success" icon @click="print('rptcard')">
          <v-icon>print</v-icon>
        </v-btn>
      </template>
    </cm-dialog>
  </v-card>
</template>
<style>
#rptcard .v-table thead th {
  white-space: normal !important;
  color:#000;
  font-weight:bold;
}

#bill .v-table thead th {
  white-space: normal !important;
  color:#000;
  font-weight:bold;
}
table.v-table tbody td{
  color:#000;
}
</style>
<script>
import Modal from "../../../components/Modal";
import SBill from "../../../components/student/bill";
import RCard from "../../../components/student/reportCard";
import { mapGetters } from "vuex";
export default {
  name: "classes-view",
  metaInfo() {
    return { title: this.$t("classes") };
  },
  components: {
    "cm-dialog": Modal,
    "s-bill": SBill,
    "report-card": RCard
  },
  data() {
    return {
      showD: false,
      showR: false,
      showB: false,
      ntmodal: false,
      ntmodal2: false,
      search: "",
      next_term_date: "",
      selected_class: {},
      selected_classb: {},
      selected_student: {
        rollNo: "0012",
        s_bio: {
          name: "test"
        },
        s_class: {
          name: "Basic 1"
        }
      },
      class_model: {
        name: "",
        level: "",
        teacher_id: "",
        capacity: ""
      },
      class_modelcp: {
        name: "",
        level: "",
        teacher_id: "",
        capacity: ""
      },
      classes_headers: [
        {
          text: "SN",
          align: "center",
          sortable: true,
          value: "level"
        },
        {
          text: "Class",
          align: "center",
          sortable: false,
          value: "name"
        },
        {
          text: "Code",
          align: "center",
          sortable: false,
          value: "code"
        },
        {
          text: "Level",
          align: "center",
          sortable: false,
          value: "level"
        },
        {
          text: "Teacher",
          align: "center",
          sortable: true,
          value: "teacher_id"
        },
        {
          text: "Capacity",
          align: "center",
          sortable: true,
          value: "capacity"
        },
        {
          text: "Total Students",
          align: "center",
          sortable: false,
          value: "total_stds"
        },
        {
          text: "Actions",
          align: "center",
          sortable: false,
          value: "name"
        }
      ]
    };
  },
  mounted() {
    //console.log(this.cerrors)

    this.$store.dispatch("classes/getAll");

  },
  computed: {
    ...mapGetters({
      classes: "classes/CLASSES",
      cerrors: "classes/CLASS_ERROR",
      loading: "classes/CLASS_LOADING",

      teachers: "teachers/TEACHERS"
    })
  },
  methods: {
    addclass() {
      this.$store.dispatch("classes/add", this.class_model);

      if (this.cerrors == null) {
        this.class_model = {};
        this.$store.dispatch("responseMessage", {
          type: "success",
          text: "Class added successfully.",
          title: "Classes",
          modal: false
        });
      }
    },
    deleteclass(classroom, index) {
      if (confirm("Are you sure you want to delete this class?")) {
        let idx = this.classes.indexOf(classroom);
        this.$store.dispatch("classes/delete", { classroom, index: idx });
        this.$store.dispatch("responseMessage", {
          type: "success",
          text: "Class deleted successfully.",
          title: "Classes",
          modal: false
        });
      }
    },

    editclass(classroom) {
      this.editedIndex = this.classes.indexOf(classroom);
      this.class_model = Object.assign({}, classroom);
      this.class_model.teacher_id = classroom.teacher?classroom.teacher.id:''

      //alert(this.editedIndex)

      this.showD = true;
    },
    updateclass(classroom, index) {
      this.$store.dispatch("classes/update", { index, classroom });

      if (this.cerrors == null) {
        this.class_model = {};
        this.editedIndex = -1;
        this.showD = false;
        this.$store.dispatch("responseMessage", {
          type: "success",
          text: "Class updated successfully.",
          title: "Classes",
          modal: false
        });
      }
    },
    saveclass() {
      if (!this.$refs.form.validate()) {
        return;
      }
      //decides between editing class info or saving class info
      if (this.editedIndex > -1) {
        this.updateclass(this.class_model, this.editedIndex);
      } else {
        this.addclass();
      }
    },

    // class_teacher_name(tid) {

    //   if(tid && this.teachers){
    //     let c = this.teachers.filter(t => {
    //     return t.id === tid;
    //   });

    //   let t = c?c[0]:null
    //   return t? t.name:null
    //   }

    // },
    showRpt(selclass) {
      this.selected_class = { id: selclass.id, subjects: selclass.subjects };
      this.showR = !this.showR;
    },

    showBill(selclass) {
      this.selected_classb = { id: selclass.id };
      this.showB = !this.showB;
    },

    print(doc) {
      if(this.next_term_date==""){
        alert("please set next term's date at 'next term begins' before printing")
        return
      }
      //window.print();
      //this.$htmlToPaper('printMe');

      // Get HTML to print from element
      const prtHtml = document.getElementById(doc).innerHTML;

      // Get all stylesheets HTML
      let stylesHtml = "";
      for (const node of [
        ...document.querySelectorAll('link[rel="stylesheet"], style')
      ]) {
        stylesHtml += node.outerHTML;
      }

      var toPrint = `<!DOCTYPE html>
<html>
  <head></head>
    ${stylesHtml}
  </head>
  <body>
    ${prtHtml}
  </body>
  <style>
    .theme--light.v-table thead th {
      white-space: normal !important;
      color:#000;
      font-weight:bold;
    }

  </style>
</html>`;

      // Open the print window
      const WinPrint = window.open(
        "",
        "",
        "left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0"
      );

      WinPrint.document.write(toPrint);

      WinPrint.document.close();
      WinPrint.focus();

      if (WinPrint.document.readyState === "complete") {
        setTimeout(function() {
          WinPrint.print();
          WinPrint.close();
        }, 1300);
      }

      //WinPrint.print();
      //WinPrint.close();
    }
  },
  watch: {
    showD(val) {
      if (val == false) {
        this.class_model = {};
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/admin/classes/classes.vue